import { appQueryClient } from '~/adapters/reactQuery';
import { surveyTypesQueries } from '../queries/surveyTypes.queries';

export const surveyTypesKeys = {
  fetchCompanySurveyTypes: ({ companyId, lang }: { companyId: number; lang: string }) => [
    'surveyTypes',
    { companyId, lang },
  ],
};

export const fetchCompanySurveyTypesQuery = ({ companyId, lang }: { companyId: number; lang: string }) => {
  return appQueryClient.fetchQuery({
    queryKey: surveyTypesKeys.fetchCompanySurveyTypes({ companyId, lang }),
    queryFn: () => surveyTypesQueries.fetchCompanySurveyTypes({ companyId, lang }),
  });
};
